/**
 * Return
 * Handles all small interactions on Return screen
 * and validations before submit
 */

import 'parsleyjs';
import { returnFileUploadHandler } from 'account/returns';
import SENTRY from '../custom/sentry.js';

custom.returnForm = (() => {
  // Variables
  const returnFormClass = 'js-return-order';
  const returnProductSelector = '[data-returing-product]';
  const dateSelectorClass = `${returnFormClass}--date`;
  const replacementSelectorClass = `${returnFormClass}--replacement`;
  const reasonSelectorClass = `${returnFormClass}--reason`;
  const imageUploaderClass = `${returnFormClass}--image`;
  const productLabelImageUploaderClass = `${returnFormClass}--product-label-image`;
  const damageImageUploaderClass = `${returnFormClass}--damage-image`;
  const productCheckBox = "[name='Return Products']";

  const returnNoteClass = 'js-return-note';
  let returnNoteCache = [];

  /*
   * Date picker
   * Documentation: https://github.com/dbushell/Pikaday
   */
  var pikaday = require('pikaday');

  const datePickerClass = 'datepicker';
  const buffer = 0;

  //const datePickerRadioId = "ShippingDate";

  /*
   * Latest Date
   *
   * Date user recieved product order.
   * Prevent user from choosing date in future.
   */
  function latestDate() {
    const date = new Date(); // Today FOR NOW
    date.setDate(date.getDate() + buffer);

    return date;
  }

  function recievedDatePickerInit($picker) {
    var picker = new pikaday({
      field: $picker[0],
      format: 'MMM DD, YYYY',
      maxDate: latestDate(),
      defaultDate: latestDate(),
      setDefaultDate: false,
      showDaysInNextAndPreviousMonths: true,
      i18n: {
        previousMonth: 'Previous',
        nextMonth: 'Next',
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        weekdays: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      },
      onSelect: function (date) {
        // dateValueSetter(picker.toString());
      },
    });
  }

  function imageUploaderDisplayHandler(event = null) {
    const reason = $(event.target).val();
    const $imageUploader = $(event.target)
      .closest(returnProductSelector)
      .find(`.${imageUploaderClass}`);
    const $productLabelImageUploader = $(event.target)
      .closest(returnProductSelector)
      .find(`.${productLabelImageUploaderClass}`);
    const $damageImageUploader = $(event.target)
      .closest(returnProductSelector)
      .find(`.${damageImageUploaderClass}`);
    switch (reason) {
      case 'Damaged':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.removeClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', true);
        break;
      case 'Defective':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.removeClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', true);
        break;
      case 'Duplicative Order':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
      case 'Received Wrong Product':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
      case 'Ordered Wrong Product':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
      case 'Color Not as Pictured':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.removeClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', true);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
      case 'Dissatisfied':
        $imageUploader.removeClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', true);
        $productLabelImageUploader.addClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', false);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
      default:
        $imageUploader.addClass('hidden');
        $imageUploader.find("input[type='file']").prop('required', false);
        $productLabelImageUploader.addClass('hidden');
        $productLabelImageUploader
          .find("input[type='file']")
          .prop('required', false);
        $damageImageUploader.addClass('hidden');
        $damageImageUploader.find("input[type='file']").prop('required', false);
        break;
    }
  }

  /*
   * conditionalValidationToggle
   *
   * In return form, there are some input fields
   * which will get to be required depending on other selection.
   * This method just toggle required attribute on those.
   */
  function conditionalValidationToggle(event = null) {
    const $returnProduct = $(event.target).closest(returnProductSelector);
    const $replacementSelector = $returnProduct.find(
      `.${replacementSelectorClass}`,
    );
    const $reasonSelector = $returnProduct.find(`.${reasonSelectorClass}`);
    const $dateSelector = $returnProduct.find(`.${dateSelectorClass}`);

    !this.checked
      ? $returnProduct.removeClass('return-product--checked')
      : $returnProduct.addClass('return-product--checked');
    !this.checked
      ? $replacementSelector.prop('required', false)
      : $replacementSelector.prop('required', true);
    !this.checked
      ? $reasonSelector.prop('required', false)
      : $reasonSelector.prop('required', true);
    !this.checked
      ? $reasonSelector.prop('required', false)
      : $dateSelector.prop('required', true);
  }

  function formSuccessHandler($form = null, data = null) {
    const inputArr = $form.serializeArray();
    const rtnProductArr = data.fields[0].value;
    let payload = '';
    let consolidatedData = '';
    let bOrderInfo = false;

    var regExp = /\(([^)]+)\)/; // Inside Parentheses
    const $submitButton = $form.find('button[type=submit]');
    $submitButton.html(
      "Submitting<span class='ellipsis'><span>.</span><span>.</span><span>.</span></span>",
    );
    inputArr.forEach((input, index) => {
      const productName = regExp.exec(input.name)
        ? regExp
            .exec(input.name)[0]
            .substr(1, regExp.exec(input.name)[0].length - 2)
        : null;

      if (!productName || rtnProductArr.includes(productName)) {
        if (window.LoloiConfig.erp_source == 'NETSUITE') {
          //CONSOLIDATE PAYLOAD INTO SINGLE HIDDEN FIELD
          if (input.name == 'Return Products') {
            if (!bOrderInfo) {
              consolidatedData +=
                'Order' +
                '=' +
                $(`.${returnFormClass}-id`).text() +
                '\n' +
                input.name +
                '=' +
                rtnProductArr.join(', ') +
                '\n';
              consolidatedData += '=================\n';
              bOrderInfo = true;
            } else {
              consolidatedData += '=================\n';
            }
          } else {
            if (rtnProductArr.includes(productName)) {
              consolidatedData += input.name + '=' + input.value + '\n';
            }
          }
        } else {
          if (index != 0) payload += '&';
          if (input.name == 'Return Products') {
            payload +=
              encodeURIComponent('Order') +
              '=' +
              $(`.${returnFormClass}-id`).text() +
              '&' +
              encodeURIComponent(input.name) +
              '=' +
              rtnProductArr.join(', ');
          } else {
            payload +=
              encodeURIComponent(input.name) +
              '=' +
              encodeURIComponent(input.value);
          }
        }
      }
    });

    if (window.LoloiConfig.erp_source == 'NETSUITE') {
      //CONSOLIDATE PAYLOAD INTO SINGLE HIDDEN FIELD
      document.getElementById('incomingmessage').value = consolidatedData;
      $form.submit();
    } else {
      const orderId = $(`.${returnFormClass}-id`).text();
      let newLink = '/account?view=return-confirm&orderId=' + orderId;
      let endpointLink = 'https://usebasin.com/f/fe64a86dd310.json';
      $.ajax({
        type: 'POST',
        url: endpointLink,
        data: payload,
        success: function (response) {
          $submitButton.html('Submitted');
          window.location.href = newLink;
        },
        error: function (response) {
          custom.utils.sendCustomSentryError(
            `Return Form Failed`,
            {
              extra: {error: response},
              tags: {module: 'Return Form', category: SENTRY.CATEGORIES.ORDERS},
            },
          );
        },
      });
    }
  }

  /*
   * returnNoteHandler
   *
   * Get Cart Special Instructions value and call Shopify API to save
   * @param {object} e - click event object
   */
  function returnNoteHandler(e) {
    e.stopPropagation();
    e.preventDefault();
    const $target = $(e.target);
    const $item = $target.closest(`.${returnNoteClass}`);
    const line = $item.data('note-id') ? $item.data('note-id') : null;

    const $note = $item.find('textarea.ReturnNote');

    const $label = $item.find(`label.${returnNoteClass}--edit`);
    const $displayContainer = $item.find(`.${returnNoteClass}--display`);
    const $inputContainer = $item.find(`.${returnNoteClass}--input`);
    const $controlContainer = $item.find(`.${returnNoteClass}--control`);
    const $holder = $item.find(`.${returnNoteClass}--holder`);

    function openInputField(openAccordion = true) {
      openAccordion
        ? custom.Accordion.openItem($inputContainer)
        : custom.Accordion.closeItem($inputContainer);
      $displayContainer.addClass('hidden');
      $controlContainer.addClass('hidden');
      $label.removeClass('hidden');
    }
    function closeInputField(closeAccordion = true) {
      if (closeAccordion) custom.Accordion.closeItem($inputContainer);
      $displayContainer.removeClass('hidden');
      $controlContainer.removeClass('hidden');
      $label.addClass('hidden');
    }

    function displayHandler(text = '') {
      $note.val(text);
      $holder.text(text);
      returnNoteCache[line] = text;
    }

    if ($target.hasClass(`${returnNoteClass}--save`)) {
      $note.val() != '' ? closeInputField() : openInputField(false);
      displayHandler($note.val());
    } else if ($target.hasClass(`${returnNoteClass}--cancel`)) {
      returnNoteCache[line] != '' ? closeInputField() : openInputField(false);
      displayHandler(returnNoteCache[line]);
    } else if ($target.hasClass(`${returnNoteClass}--edit`)) {
      openInputField();
    } else if ($target.hasClass(`${returnNoteClass}--remove`)) {
      openInputField(false);
      displayHandler();
    }
  }

  /*
   * initialization
   *
   * NOTE: this initialization gets called when "returnDetailRendered" happens, which is triggered in mu-app.js with pubsub library
   */
  const init = () => {
    $.each($(returnProductSelector), (index, product) => {
      // Date Picker Initialize
      recievedDatePickerInit($(product).find(`.${datePickerClass}`));
      // Validation Toggle
      $(product)
        .find(productCheckBox)
        .on('change', conditionalValidationToggle);
      // Image Uploader Handler
      $(`.${reasonSelectorClass}`).on('change', imageUploaderDisplayHandler);
    });

    custom.FormNumbers.init();
    custom.formSelect.init();
    custom.Accordion.init();
    custom.typeDesignId.init();

    // Form Validation
    if ($(`.${returnFormClass}`).length > 0) {
      $(`.${returnFormClass}`)
        .parsley(custom.utils.parsleyOption())
        .on('form:submit', (data) => {
          formSuccessHandler($(`.${returnFormClass}`), data);
          return false;
        });
    }

    // Quantity Update of returning products
    $("[name='Return Products']").each((index, el) => {
      $(el).on('click', () =>
        $('.js-return-form-qty').text(
          $("[name='Return Products']:checked").length,
        ),
      );
    });

    // Note Handler
    $(
      `.${returnNoteClass}--save, .${returnNoteClass}--cancel, .${returnNoteClass}--edit, .${returnNoteClass}--remove`,
    ).on('click', returnNoteHandler);

    window.pubsub.trigger('returnDetailRenderFinished');
    if ($('.js-return-order--netsuite').length) {
      const customerID = window.customerId ? window.customerId : null;
      returnFileUploadHandler(customerID);
    }
  };

  return {
    returnNoteHandler,
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/return-form.js